/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  AssetDetailService,
  IAssetDetailMethods,
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IHeaderMethods,
  HeaderService,
} from "./components";

export type AssetDetailPageAgent = IAssetDetailMethods &
  IStaticPageContentMethods &
  IHeaderMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new AssetDetailService(),
    new LoadingService(),
    new StaticPageContentService(),
    new HeaderService(),
  ];
};

export const getAgent = () => {
  return createAgent<AssetDetailPageAgent>({
    plugins: getPlugins(),
  });
};
